__webpack_public_path__ = window.__WEBP_PUBLIC_PATH__; //eslint-disable-line